<template>
  <div class="background" id="background">
    <div class="chart-container" id="chart-container">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('Device Settings Report')}}</p>
          <p style="font-size: 9px;">{{$t('Device Settings at')}} {{time}}</p>
        </div>
      </div>
      <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isFr}">
        <tr>
          <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
          <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
        </tr>
        <tr>
          <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
          <td class="td2">{{pdmTitle}}</td><td colspan="8" class="td3">{{pdmSN}}</td>
        </tr>
        <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{tranSN}}</td></tr>
        <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{pumpSN}}</td></tr>
        <tr>
          <td class="td1 td4">{{$t('disType')}}</td><td colspan="4" class="td4">{{statics.medical_history}}</td>
          <td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>
        </tr>
      </table>
      <div class="small-hr"></div>

      <div class="statics" style="margin-top: 30px;">
        <p>{{$t('basal')}}</p>
        <table class="statics-table">
          <tr>
            <td class="td3">{{$t('MaxBasalRate')}}: {{basal.max_rate}} {{$t('basal_unit2')}}</td>
            <td class="td3">{{$t('Selected Basal Pattern')}}: {{basal.basal_select}}</td>
            <td>{{$t('BasalPatterns')}}: {{basal.basal_onoff}}</td>
          </tr>
        </table>
      </div>
      <div class="context">
        <!-- <p>{{basal.basal_select}}</p> -->
        <div id="chart6_1" class="graph"></div>
        <div id="chart6_2" class="graph"></div>
        <div id="chart6_3" class="graph"></div>
        <div id="chart6_4" class="graph"></div>
        <div id="chart6_5" class="graph"></div>
        <div v-show="moreBasal">
          <div id="chart6_6" class="graph"></div>
          <div v-if="moreBasal">
            <div class="page-seperator2"></div>
            <div class="page-starter"><!--<br/><br/>--></div>
          </div>
          <div id="chart6_7" class="graph"></div>
          <div id="chart6_8" class="graph"></div>
        </div>
      </div>

      <!--
      <div class="page-seperator"></div>
      <div class="page-starter"><br/><br/><br/><br/></div>-->

      <div v-show="!moreBasal">
        <div class="page-seperator5"></div>
        <div class="page-starter"><!--<br/><br/><br/><br/><br/>--></div>
      </div>

      <div v-for="(item, index) in this.basalInfo">

        <div v-if="index==basalPagePos+1">
          <div>
            <div class="page-seperator45" :id="'basalPage'+index"></div>
            <div class="page-starter"><!--<br/><br/>--></div>
          </div>
        </div>

        <div v-if="index==basalPagePos2+1">
          <div>
            <div class="page-seperator3" :id="'basalPage2'+index"></div>
            <div class="page-starter"><!--<br/><br/>--></div>
          </div>
        </div>

        <div class="statics">
          <p class="custom">{{item.title}}</p>
          <span style="float: right;margin-right: 30px;">{{$t('24h Total')}}: {{item.total}}{{$t('ins_unit2')}}</span>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg1" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg1" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics" v-show="(item.bsg2show)">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg2" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg2" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics" v-show="(item.bsg3show)">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg3" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg3" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics" v-show="(item.bsg4show)">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg4" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg4" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
      </div>

      <!--
      <div class="statics">
        <p class="custom">{{basal.basal_select}}</p>
        <span style="float: right;margin-right: 30px;">{{$t('24h Total')}}:   {{total}}U/H</span>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td v-for="i in bsg1" class="td1">{{i[0]}}</td>
          </tr>
          <tr>
            <td class="td3">U/H</td><td v-for="i in bsg1" class="td3">{{i[1]}}</td>
          </tr>
        </table>
      </div>
      <div class="statics" v-show="(bsg2.length>0)">
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td v-for="i in bsg2" class="td1">{{i[0]}}</td>
          </tr>
          <tr>
            <td class="td3">U/H</td><td v-for="i in bsg2" class="td3">{{i[1]}}</td>
          </tr>
        </table>
      </div>
      <div class="statics" v-show="(bsg3.length>0)">
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td v-for="i in bsg3" class="td1">{{i[0]}}</td>
          </tr>
          <tr>
            <td class="td3">U/H</td><td v-for="i in bsg3" class="td3">{{i[1]}}</td>
          </tr>
        </table>
      </div>
      <div class="statics" v-show="(bsg4.length>0)">
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td v-for="i in bsg4" class="td1">{{i[0]}}</td>
          </tr>
          <tr>
            <td class="td3">U/H</td><td v-for="i in bsg4" class="td3">{{i[1]}}</td>
          </tr>
        </table>
      </div>-->

      <div v-show="bolusStartPage.show">
        <div class="page-seperator4" id="bolusStartPage"></div>
        <div class="page-starter"><!--<br/><br/><br/><br/>--></div>
      </div>

      <div class="statics" style="margin-top: 30px;">
        <p>{{$t('bolus')}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Maximum Bolus')}}: {{bolus.max_bolus}} {{$t('ins_unit2')}}</td>
            <td class="td1">{{$t('Bolus Increment')}}: {{bolus.bolus_step}} {{$t('ins_unit2')}}</td>
            <td class="td2">{{$t('Bolus Calculator')}}: {{bolus.bolus_wizard}}</td>
          </tr>
          <tr>
            <td class="td3">{{$t('Combo/Ext Bolus')}}: {{bolus.extent_option}}</td>
            <td class="td3">{{$t('BG Reminder')}}: {{bolus.bg_reminder}}</td>
            <td>{{$t('Active Insulin Time')}}: {{bolus.ins_active_time}} H</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('IC Ratios')}}(g/{{$t('ins_unit2')}})</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td class="td1" v-for="i in IcRatio">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('carbs')}}</td><td class="td3" v-for="i in IcRatio">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('Insulin Sensitivity')}}(mmol/L/{{$t('ins_unit2')}})</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td v-for="i in ins_sen" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('BG')}}</td><td v-for="i in ins_sen" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('BG Target')}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('From')}}</td><td v-for="i in bg_target" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('Range')}}</td><td v-for="i in bg_target" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('Bolus Reminder')}}{{maxBolOption}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('From')}}</td><td v-for="i in bolus_rem" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('To')}}</td><td v-for="i in bolus_rem" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>

      <div v-if="!showEasyPatch">
        <div v-show="pdmStartPage.show">
          <div class="page-seperator4" id="pdmStartPage"></div>
          <div class="page-starter"><!--<br/><br/><br/><br/>--></div>
        </div>

        <div class="statics" style="margin-top: 30px;">
          <p>{{$t('pdm')}}</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Audio Options')}}: {{userset.alarm_type}}</td>
              <td class="td1">{{$t('Patch Expiration')}}:{{userset.patch_expire_alarm}}</td>
              <td class="td2">{{$t('Sensor Expiration')}}: {{userset.sensor_expire_option}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Low Reservoir')}}: {{userset.low_reservoir_time}}</td>
              <td class="td1">{{$t('Auto Off')}}: {{userset.auto_off_option}}</td>
              <td class="td2">{{$t('Confidence Reminder')}}:{{userset.cmd_response}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Hourly Max')}}: {{userset.hour_bolus_max}}{{$t('ins_unit2')}}</td>
              <td class="td1">{{$t('Daily Max')}}: {{userset.day_bolus_max}}{{$t('ins_unit2')}}</td>
              <td class="td2">{{$t('Low Suspend')}}: {{userset.suspend_on_lowbg_option}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Predictive Low Suspend')}}: {{userset.pre_suspend_on_lowbg_option}}</td>
              <td class="td3"></td>
              <td></td>
            </tr>
          </table>
        </div>
        <div class="statics" style="margin-top: 20px;">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Time Format')}}:{{userset.time_style}}</td>
              <td class="td1">{{$t('uername')}}:{{userset.user_name}}</td>
              <td class="td2">{{$t('Dispay Settings (Screen)')}}:{{userset.screen_timeout}}{{$t('Sec')}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Dispay Settings (Backlight)')}}:{{userset.screen_timeout}}{{$t('Sec')}}</td>
              <td class="td1">{{$t('Device Options（CGM System)')}}:{{userset.cgms_module_flag}}</td>
              <td class="td2">{{$t('Device Options（Insulin Pump)')}}:{{userset.pump_module_flag}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Glucose Unit')}}:{{userset.glucose_unit}}</td>
              <td class="td3">{{$t('Alarm Clock')}} :{{userset.clock_option}}</td>
              <td></td>
            </tr>
          </table>
        </div>

        <!--
        <div class="page-seperator"></div>
        <div class="page-starter"><br/><br/><br/><br/></div>-->

        <div class="statics">
          <p class="custom">{{$t('Alarm Clock')}} ({{userset.clock_option}})</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('time')}}</td><td v-for="i in userset.clock" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Repeat')}}</td><td v-for="i in userset.clock" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
            </tr>
          </table>
        </div>

        <div v-show="cgmStartPage.show">
          <div class="page-seperator3" id="cgmStartPage"></div>
          <div class="page-starter"><!--<br/><br/><br/><br/>--></div>
        </div>

        <div class="statics" style="margin-top: 30px;">
          <p style="float: left">{{$t('CGM')}}</p>
          <div class="spe-text">
            <p>{{$t('Glucose Alerts')}}:  {{cgm.sensor_alarm_option}}</p>
            <p>{{$t('Alert Silence')}}:  {{cgm.alarm_silent_option}}</p>
          </div>
          <div class="statics" style="clear: both">
            <p class="custom">{{$t('Glucose Limits')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('From')}}</td><td v-for="i in cgmLimit" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Low')}}</td><td v-for="i in cgmLimit" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td3">{{$t('High')}}</td><td v-for="i in cgmLimit" class="td3">{{i[2]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="statics small-table">
          <p class="custom" style="float: left">{{$t('Predicitive Alerts')}} (hh:mm)</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('high1')}}</td><td class="td1">{{cgm.sensor_forecast_alarm.high[0]}}</td><td class="td2">{{cgm.sensor_forecast_alarm.high[1]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('low1')}}</td><td class="td3">{{cgm.sensor_forecast_alarm.low[0]}}</td><td>{{cgm.sensor_forecast_alarm.low[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics small-table">
          <p class="custom" style="float: left">{{$t('Rate Alerts')}} ({{unit1}}/min)</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Rise')}}</td><td class="td1">{{cgm.sensor_rate_alarm.rise[0]}}</td><td class="td2">{{cgm.sensor_rate_alarm.rise[1]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Fall')}}</td><td class="td3">{{cgm.sensor_rate_alarm.fall[0]}}</td><td>{{cgm.sensor_rate_alarm.fall[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics small-table">
          <p class="custom" style="float: left">{{$t('Snooze')}} (hh:mm)</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('high1')}}</td><td class="td1">{{cgm.sensor_alarm_repeat.high[0]}}</td><td class="td2">{{cgm.sensor_alarm_repeat.high[1]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('low1')}}</td><td class="td3">{{cgm.sensor_alarm_repeat.low[0]}}</td><td>{{cgm.sensor_alarm_repeat.low[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics middle-table">
          <p class="custom" style="float: left">{{$t('calib')}}</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Calibration Reminder')}}</td><td class="td1">{{cgm.sensor_alarm_settings.calib_remind_option}}</td>
              <td class="td2">{{cgm.sensor_alarm_settings.calib_remind_time}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Calibration Repeat')}}</td><td class="td1">{{cgm.sensor_alarm_settings.calib_remind_interval}}</td><td></td>
            </tr>
            <tr>
              <td class="td3">{{$t('Graph Range')}}</td><td class="td3">{{cgm.sensor_alarm_settings.trend_time_scope}}H</td><td></td>
            </tr>
          </table>
        </div>
        <div style="clear:both;"></div>

        <div class="part statics">
          <!--          <div class="tit1e">-->
          <!--            <span>&nbsp;{{$t('Auto Mode')}}</span>-->
          <!--          </div>-->
          <p>&nbsp;{{$t('t1222_Auto_Mode')}}</p>

          <div class="statics" style="margin-top: 30px;">
            <!--<p style="float: left">{{$t('CGM')}}</p>-->
            <div class="spe-text">
              <p>{{$t('t1222_Auto_Mode')}}:  {{userset.auto_basal.autobasalflag}}</p>

            </div>
            <div class="statics" style="clear: both">

              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('t1029_Target_SG')}}: {{userset.auto_basal.BGTarget}}</td>

                  <td class="td1">{{$t('t1029_Auto_Meal_Handling')}}: {{userset.auto_basal.nFoodFlag}}</td>

                  <td class="td1">{{$t('weight')}}: {{userset.auto_basal.AutoBasalWeight}} kg </td>
                </tr>

                <tr>
                  <td class="td3">{{$t('t1029_Total_Daily_Dose')}}: {{userset.auto_basal.AutoBasalTDD}} U</td>

                  <td class="td3"></td>
                  <td class="td3"></td>
                </tr>
              </table>
            </div>
          </div>

        </div>

      </div>

      <div v-else>

        <div v-show="pumpStartPage.show">
          <div class="page-seperator3" id="pumpStartPage"></div>
          <div class="page-starter"></div>
        </div>

        <div class="part part1">

          <!--<div class="tit1e">
            <span>&nbsp;{{$t('pump')}}</span>
          </div>-->

          <div class="statics" style="margin-top: 30px;">
            <p>{{$t('Pump')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('t1108_Pump_Bash_SN')}}: {{pumpSN}}</td>
                <td class="td1">{{$t('Patch Expiration')}}:{{userset.patch_expire_alarm}}</td>
                <td class="td2">{{$t('Low Reservoir')}}: {{userset.low_reservoir_time}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('t1102_Out_of_Range')}}: {{userset.out_of_range_option}}</td>
                <td class="td1">{{$t('t1102_Command_Reminder')}}: {{userset.cmd_response}}</td>
                <td class="td2">{{$t('Auto Off')}}: {{userset.auto_off_option}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('Daily Max')}}: {{userset.day_bolus_max}}{{$t('ins_unit2')}}</td>
                <td class="td3">{{$t('Hourly Max')}}: {{userset.hour_bolus_max}}{{$t('ins_unit2')}}</td>
                <td class=""></td>
              </tr>
            </table>
          </div>

          <div class="small-table-wrap">
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1102_Alarms_Alerts_on_APP')}} </p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('t1112_Audio')}}</td>
                  <td class="td2">{{userset.pump_alarm_audio_option}}</td>
                </tr>

                <tr>
                  <td class="td1">{{$t('Vibrate')}}</td>
                  <td class="td2">{{userset.pump_alarm_vibrate_option}}</td>
                </tr>

                <tr>
                  <td class="td3">{{$t('t1029_Pump_Light')}}</td>
                  <td class="">{{userset.easypatch_pump_light}}</td>
                </tr>
              </table>
            </div>
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1102_Alarms_on_App')}}</p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Repeat')}}</td>
                  <td class="td2">{{userset.easypatch_pump_alarm_repeat}}</td>
                </tr>
                <tr>
                  <td class="td1">{{$t('Snooze')}}</td>
                  <td class="td2">{{userset.easypatch_pump_alarm_snooze}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1112_Tone')}}</td>
                  <td>{{userset.easypatch_pump_alarm_tone}}</td>
                </tr>
              </table>
            </div>
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1102_Alerts_on_App')}}</p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Repeat')}}</td>
                  <td class="td2">{{userset.easypatch_pump_alert_repeat}}</td>
                </tr>
                <tr>
                  <td class="td1">{{$t('Snooze')}}</td>
                  <td class="td2">{{userset.easypatch_pump_alert_snooze}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1112_Tone')}}</td>
                  <td>{{userset.easypatch_pump_alert_tone}}</td>
                </tr>
              </table>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>

        <div class="part">
          <!--<div class="tit1e">
            <span>&nbsp;{{$t('CGM')}}</span>
          </div>-->

          <div class="statics" style="margin-top: 30px;">
            <p>{{$t('CGM')}}</p>
            <!--<div class="spe-text">
              <p>{{$t('Glucose Alerts')}}:  {{cgm.sensor_alarm_option}}</p>
              <p>{{$t('Alert Silence')}}:  {{cgm.alarm_silent_option}}</p>
            </div>-->

            <div class="statics" style="margin-top: 30px;">
              <!--<p>{{$t('pdm')}}</p>-->
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('t1108_Transmitter_SN')}}: {{tranSN}}</td>
                  <td class="td1">{{$t('Sensor Expiration')}}:{{userset.sensor_expire_option}}</td>
                  <td class="td2">{{$t('Glucose Alerts')}}: {{cgm.sensor_alarm_option}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1102_Factory_Calibration')}}: {{userset.factory_calibration_option}}</td>
                  <td class="td3"></td>
                  <td class="td3"></td>
                </tr>
              </table>
            </div>

            <div class="statics" style="clear: both">
              <p class="custom">{{$t('Glucose Limits')}}</p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('From')}}</td><td v-for="i in cgmLimit" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
                </tr>
                <tr>
                  <td class="td1">{{$t('Low')}}</td><td v-for="i in cgmLimit" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('High')}}</td><td v-for="i in cgmLimit" class="td3">{{i[2]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="table-group-wrap1">
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('Predicitive Alerts')}} (hh:mm)</p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('high1')}}</td>
                  <td class="td1">{{cgm.sensor_forecast_alarm.high[0]}}</td>
                  <td class="td2">{{cgm.sensor_forecast_alarm.high[1]}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('low1')}}</td>
                  <td class="td3">{{cgm.sensor_forecast_alarm.low[0]}}</td>
                  <td>{{cgm.sensor_forecast_alarm.low[1]}}</td>
                </tr>
              </table>
            </div>
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('Rate Alerts')}} ({{unit1}}/min)</p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Rise')}}</td>
                  <td class="td1">{{cgm.sensor_rate_alarm.rise[0]}}</td>
                  <td class="td2">{{cgm.sensor_rate_alarm.rise[1]}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('Fall')}}</td>
                  <td class="td3">{{cgm.sensor_rate_alarm.fall[0]}}</td>
                  <td>{{cgm.sensor_rate_alarm.fall[1]}}</td>
                </tr>
              </table>
            </div>
            <div style="clear:both;"></div>
          </div>

          <div class="table-group-wrap1">
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1102_Alerts_for_Low')}} </p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Repeat')}}</td>
                  <td class="td2">{{cgm.easypatch_cgm_alerts_low_repeat}}</td>
                </tr>
                <tr>
                  <td class="td1">{{$t('Snooze')}}</td>
                  <td class="td2">{{cgm.easypatch_cgm_alerts_low_snooze}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1112_Tone')}}</td>
                  <td>{{cgm.easypatch_cgm_alerts_low_tone}}</td>
                </tr>
              </table>
            </div>
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1102_Alerts_for_High')}} </p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Repeat')}}</td>
                  <td class="td2">{{cgm.easypatch_cgm_alerts_high_repeat}}</td>
                </tr>
                <tr>
                  <td class="td1">{{$t('Snooze')}}</td>
                  <td class="td2">{{cgm.easypatch_cgm_alerts_high_snooze}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1112_Tone')}}</td>
                  <td>{{cgm.easypatch_cgm_alerts_high_tone}}</td>
                </tr>
              </table>
            </div>
            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1102_Alerts_for_Others')}}</p>
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Repeat')}}</td>
                  <td class="td2">{{cgm.easypatch_cgm_alerts_other_repeat}}</td>
                </tr>
                <tr>
                  <td class="td1">{{$t('Snooze')}}</td>
                  <td class="td2">{{cgm.easypatch_cgm_alerts_other_snooze}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1112_Tone')}}</td>
                  <td>{{cgm.easypatch_cgm_alerts_other_tone}}</td>
                </tr>
              </table>
            </div>

            <div class="statics small-table">
              <p class="custom" style="float: left">{{$t('t1029_Alerts_for_Hypo')}} </p>
              <table class="statics-table">

                <tr>
                  <td class="td3">{{$t('t1112_Tone')}}</td>
                  <td>{{cgm.easypatch_cgm_alerts_hypo_tone}}</td>
                </tr>
              </table>
            </div>

            <div style="clear:both;"></div>
          </div>
        </div>

        <div v-show="appStartPage.show">
          <div class="page-seperator3" id="appStartPage"></div>
          <div class="page-starter"></div>
        </div>

        <div class="part">
          <!--<div class="tit1e">
            <span>&nbsp;{{$t('APP')}}</span>
          </div>-->

          <div class="statics" style="margin-top: 30px;">

            <div class="statics" style="margin-top: 30px;">
              <p>{{$t('APP')}}</p>
              <!--<p>{{$t('pdm')}}</p>-->
              <table class="statics-table">
                <tr>
                  <td class="td1">{{$t('Name')}}: {{userset.user_name}}</td>
                  <td class="td1">{{$t('Audio Options')}}: {{userset.alarm_type}}</td>
                  <td class="td2">{{$t('Glucose Unit')}}: {{userset.glucose_unit}}</td>
                </tr>
                <tr>
                  <td class="td3">{{$t('t1112_Weight_Unit')}}: {{userset.easypatch_weight_unit}}</td>
                  <td class="td3">{{$t('t1112_Height_Unit')}}: {{userset.easypatch_height_unit}}</td>
                  <td class="td3"></td>
                </tr>
              </table>
            </div>

          </div>

        </div>

        <!-- EasyLoop -->
        <div class="part">
          <!--<div class="tit1e">
            <span>&nbsp;{{$t('EasyLoop')}}</span>
          </div>-->

          <div class="statics" style="margin-top: 30px;">

            <div class="statics" style="margin-top: 30px;">
              <p>{{$t('EasyLoop')}}</p>
              <!--<p>{{$t('pdm')}}</p>-->
              <table class="statics-table">
                <tr>
                  <td class="td3">{{$t('Low Suspend')}}: {{userset.suspend_on_lowbg_option}}</td>
                  <td class="td3">{{$t('Predictive Low Suspend')}}:  {{userset.pre_suspend_on_lowbg_option}}</td>
                  <td class="td3"></td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="part">
          <!--<div class="tit1e">
            <span>&nbsp;{{$t('EasyLoop')}}</span>
          </div>-->

          <div class="statics" style="margin-top: 30px;">

            <div class="statics" style="margin-top: 30px;">
              <p>{{$t('t1222_Auto_Mode')}}</p>
              <!--<p>{{$t('pdm')}}</p>-->
<!--              <table class="statics-table">-->
<!--                <tr>-->
<!--                  <td class="td3">{{$t('Low Suspend')}}: {{userset.suspend_on_lowbg_option}}</td>-->
<!--                  <td class="td3">{{$t('Predictive Low Suspend')}}:  {{userset.pre_suspend_on_lowbg_option}}</td>-->
<!--                  <td class="td3"></td>-->
<!--                </tr>-->
<!--              </table>-->

              <div class="spe-text">
                <p>{{$t('t1222_Auto_Mode')}}:  {{userset.auto_basal.autobasalflag}}</p>

              </div>

              <div class="statics" style="clear: both">

                <table class="statics-table">
                  <tr>
                    <td class="td1">{{$t('t1029_Target_SG')}}: {{userset.auto_basal.BGTarget}}</td>

                    <td class="td1">{{$t('t1029_Auto_Meal_Handling')}}: {{userset.auto_basal.nFoodFlag}}</td>

                    <td class="td1">{{$t('weight')}}: {{userset.auto_basal.AutoBasalWeight}} kg </td>
                  </tr>

                  <tr>
                    <td class="td3">{{$t('t1029_Total_Daily_Dose')}}: {{userset.auto_basal.AutoBasalTDD}} U</td>

                    <td class="td3"></td>
                    <td class="td3"></td>
                  </tr>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        time:'',rid:0, uid:0,st:0,et:0,data:{},pdm:'',isEn:false,pumpSN:'',tranSN:'',pdmSN:'',isMg:"",isDe:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],maxBolOption:'',unit1:'',isFr:false,
        basal:{
          "basal_onoff": "--",
          "basal_select": "--",
          "max_rate":'--',
          "exer_basal": {
            "day_total": '--',
            "seg": []
          }
        },
        basalSeg:[], bsg1:[],bsg2:[], bsg3:[],bsg4:[], total:0,

        pdmTitle:'',

        standardSeg:[], standardSeg1:[],standardSeg2:[], standardSeg3:[],standardSeg4:[],
        exerSeg:[], exerSeg1:[],exerSeg2:[], exerSeg3:[],exerSeg4:[],
        holidaySeg:[], holidaySeg1:[],holidaySeg2:[], holidaySeg3:[],holidaySeg4:[],
        programASeg:[], programASeg1:[],programASeg2:[], programASeg3:[],programASeg4:[],
        programBSeg:[], programBSeg1:[],programBSeg2:[], programBSeg3:[],programBSeg4:[],
        //
        programCSeg:[], programCSeg1:[],programCSeg2:[], programCSeg3:[],programCSeg4:[],
        programDSeg:[], programDSeg1:[],programDSeg2:[], programDSeg3:[],programDSeg4:[],
        sickSeg:[], sickSeg1:[], sickSeg2:[], sickSeg3:[],sickSeg4:[],
        moreBasal:true,
        showEasyPatch:false,
        basalPagePos:-9,
        basalPagePos2:-9,
        //basalEndPage:{show:false, },
        bolusStartPage:{show:false, },
        pdmStartPage:{show:false, },
        cgmStartPage:{show:false, },

        pumpStartPage:{show:false, },    // easypatch 显示设置时用
        appStartPage:{show:false, },     // easypatch 显示设置时用

        basalInfo:[{}, {}, {}, {}, {}, {}, {}, {}],

        bolus:{
          "bg_reminder": "--",
          "bg_target": [],
          "bolus_reminder": [],
          "bolus_step": '--',
          "bolus_wizard": "--",
          "extent_option": "--",
          "ins_active_time": '--',
          "ins_carb_ratio": [],
          "ins_sen": [],
          "max_bolus": '--'
        },
        IcRatio:[],ins_sen:[],bg_target:[],bolus_rem:[],cgmLimit:[],
        cgm:{
          "alarm_silent_option": "--",
          "sensor_alarm_option": "--",
          "sensor_alarm_repeat": {
            "high": [
              "--",
              "--"
            ],
            "low": [
              "--",
              "--"
            ]
          },
          "sensor_alarm_settings": {
            "auto_calib_option": "--",
            "calib_remind_interval": "--",
            "calib_remind_option": "--",
            "calib_remind_time": "--",
            "no_calib_display": "--",
            "sensor_lost_time": '--',
            "trend_time_scope": '--'
          },
          "sensor_alarm_threshold": [],
          "sensor_forecast_alarm": {
            "high": [
              "--",
              "--"
            ],
            "low": [
              "--",
              "--"
            ]
          },
          "sensor_rate_alarm": {
            "fall": [
              "--",
              '--'
            ],
            "rise": [
              "--",
              '--'
            ]
          }
        },
        userset:{
          "alarm_type": "--",
          "auto_off_option": "--",
          "auto_off_time": "--",
          "backlight_timeout":"--",
          "beep_off_tip_interval": "--",
          "beep_off_tip_option":"--",
          "cgms_module_flag": "--",
          "clock": [],
          "clock_option": "--",
          "cmd_response": "--",
          "day_bolus_max": "--",
          "device_option": "--",
          "glucose_unit": "--",
          "hour_bolus_max": "--",
          "keypad_lock": "--",
          "low_reservoir_ins": "--",
          "low_reservoir_time": "--",
          "low_reservoir_type": "--",
          "password_option": "--",
          "patch_expire_ahead": "--",
          "patch_expire_alarm": "--",
          "pre_suspend_on_lowbg_level": "--",
          "pre_suspend_on_lowbg_option": "--",
          "pump_module_flag":"--",
          "screen_timeout": "--",
          "suspend_on_lowbg_level": "--",
          "suspend_on_lowbg_option": "--",
          "time_style": "--",
          auto_basal:{}
        },

        exeBasal:[],standBasal:[],holidayBasal:[],programA:[],programB:[],programC:[],programD:[],sickBasal:[],sgMax:4,
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '12',
          fontFamily: 'SFUIText-Regular'
        },
        axisMaxArr:[],
        titlePadding: [0, 0, 8, 30],
        grid: {x: '3%', y: '15%', width: '95%', height: '60%'},
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        xLabel:['18-07-2017','19-07-2017','20-07-2017','21-07-2017','22-07-2017','23-07-2017','24-07-2017','25-07-2017',
          '26-07-2017','27-07-2017','28-07-2017','29-07-2017','30-07-2017','31-07-2017'],
      }
    },
    methods:{
      getStatics(){
        this.et= new Date(2017,9,19).getTime()/1000;
        this.st = this.et;
        let param = {
          st:this.st,
          et:this.et,
          tz:parseInt(sessionStorage.getItem('tz')),
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
        param = B64.base64encode(JSON.stringify(param));
        this.$http.get('api/v2.1/report/'+this.uid+'/data/dse',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      getAxisMax(seg) {
        let valArr=seg.map(function(e,i){
          return e[1];
        });
        let maxVal = Math.max.apply(null, valArr);
        let axisMax = (parseInt(maxVal/2)+1) * 2;
        return axisMax;
      },
      getOptionText(optionVal) {
        let optionText='--'
        if (1==optionVal) {
          optionText = this.$t('Off')
        } else if (2==optionVal) {
          optionText = this.$t('On')
        }
        return optionText;
      },
      getPdm2(){
        let ins_unit2=this.$t('ins_unit2')
        this.$http.get('api/v2.0/pdm/'+this.uid+'/settings/'+this.rid).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            this.data = res.data.settings;
            this.data.device_type = res.data.device_type;
            // 构造测试数据
            if (false) {  // 编写测试数据
              //this.data.device_type=8;
              this.data.device_type=18;

              function padInt(v, n){
                let v_str=v.toString();
                let pre_num=n-v_str.length;
                let pre_str='';
                for (let i=0; i<pre_num;i++) {
                  pre_str += '0';
                }
                return pre_str+v_str;
              }
              function minute_format(m){
                let hour=padInt(Math.floor(m/60), 2);
                let minute=padInt(m%60, 2);
                return hour+':'+minute;
              }

              let testSegs=[];
              for (let i=0; i<48; i++) {
                let minute=i*30;
                testSegs.push([minute_format(minute), parseFloat(((i%20)*0.1).toFixed(2)) ]);
              }
              //

              //console.log('testSegs:', testSegs);
              //this.data.settings.
              this.data.basal_settings.stand_basal.seg=testSegs.slice(0,40);
              this.data.basal_settings.exer_basal.seg=testSegs.slice(0, 40);
              this.data.basal_settings.holiday_basal.seg=testSegs.slice(0, 40);
              this.data.basal_settings.program_a_basal.seg=testSegs.slice(0,40);
              this.data.basal_settings.program_b_basal.seg=testSegs.slice(0,40);
              //
              this.data.basal_settings.program_c_basal.seg=testSegs.slice(0,40);
              this.data.basal_settings.program_d_basal.seg=testSegs.slice(0,40);
              this.data.basal_settings.sick_basal.seg=testSegs.slice(0,40);
              // 大剂量设置的测试数据
              let testICRSeg=[];
              for (let i=0; i<8; i++) {
                let minute=i*30;
                testICRSeg.push([minute_format(minute), 15 ]);
              }
              this.data.bolus_settings.ins_carb_ratio=testICRSeg;
              //
              let testSeg=[];
              for (let i=0; i<8; i++) {
                let minute=i*30;
                testSeg.push([minute_format(minute), "5.6-5.6" ]);
              }
              this.data.bolus_settings.bg_target=testSeg;

              //
              console.log('device setting test:', this.data);
            }
            // console.log('quick print setting:', this.data);
            if (18 == this.data.device_type) {
              this.moreBasal=true;
              this.showEasyPatch=false;
            } else if ('easypatch'==this.data.device_type){
              this.moreBasal=true;
              this.showEasyPatch=true;
            } else {
              this.moreBasal=false;
              this.showEasyPatch=false;
            }

            // 计算分页的地方
            if (true) {
              //if (this.moreBasal) {
              if (true){
                let totalRow=0;
                let prePageTotalRow=0;

                //let basalPagePos=0;
                let firstPageTotalRow=0;
                let secondPageTotalRow=0;

                let basalKey=["stand_basal", "exer_basal", "holiday_basal", "program_a_basal",
                  "program_b_basal","program_c_basal","program_d_basal","sick_basal"];
                let basalNum=5;
                let firstPageRow=16;
                if (this.moreBasal) {
                  basalNum=8;
                  firstPageRow=12;
                }

                // 第一个基础量的个数
                //let basal_pattern=this.data.basal_settings[basalKey[0]];
                //totalRow=Math.floor((basal_pattern.seg.length+11)/12);
                //
                for (let i=0; i<basalNum; i++) {
                  let basal_pattern=this.data.basal_settings[basalKey[i]];
                  totalRow += Math.floor((basal_pattern.seg.length+11)/12);
                  let nextRow=0;
                  if (i<basalNum-1) {
                    let next_basal=this.data.basal_settings[basalKey[i+1]];
                    nextRow=Math.floor((next_basal.seg.length+11)/12);
                  }
                  console.log("totalRow:", totalRow, nextRow, i);
                  if ((totalRow+nextRow)>firstPageRow && this.basalPagePos<0) {
                    this.basalPagePos=i;
                    //break;
                    firstPageTotalRow=totalRow;
                  }
                  if ((totalRow+nextRow)>(firstPageRow+16) && this.basalPagePos2<0) {
                    this.basalPagePos2=i;
                    //break;
                    secondPageTotalRow=totalRow;
                  }
                }

                //
                let leftBasalRow = 0;
                if (this.basalPagePos2>0) {
                  leftBasalRow=totalRow - secondPageTotalRow;
                } else if (this.basalPagePos>0) {
                  leftBasalRow=totalRow - firstPageTotalRow;
                } else {
                  leftBasalRow=totalRow;
                }
                console.log("basalTotalRow:", totalRow, firstPageTotalRow, secondPageTotalRow,
                  this.basalPagePos, this.basalPagePos2, leftBasalRow);
                //
                if (this.basalPagePos2>0) {  // basal 第二次 分页
                  let basalPage2Id='basalPage2'+(this.basalPagePos2+1);
                  let secondPageRow=secondPageTotalRow-firstPageTotalRow;

                  let sepNode=document.getElementById(basalPage2Id);
                  let baseRow=0;

                  if (secondPageRow+baseRow<=13) {
                    //sepNode.style.height='65mm';
                  } else if (secondPageRow+baseRow<=14) {
                    //sepNode.style.height='50mm';
                  } else if (secondPageRow+baseRow<=15) {
                    //sepNode.style.height='35mm';
                  } else if (secondPageRow+baseRow<=16) {
                    //sepNode.style.height='20mm';
                  }
                  //console.log("basalPage2Id:", basalPage2Id, secondPageRow, sepNode.style.height, sepNode.innerHTML);


                }
                //
                if (this.basalPagePos>0) {
                  let basalPageId='basalPage'+(this.basalPagePos+1);
                  console.log("basalPageId:", basalPageId);
                  let sepNode=document.getElementById(basalPageId);
                  let baseRow=0;
                  if (this.moreBasal) {
                    baseRow=4;
                  } else {
                    baseRow=0;
                  }

                  //
                  if (firstPageTotalRow+baseRow<=13) {
                    //sepNode.style.height='75mm';
                  } else if (firstPageTotalRow+baseRow<=14) {
                    //sepNode.style.height='60mm';
                  } else if (firstPageTotalRow+baseRow<=15) {
                    //sepNode.style.height='45mm';
                  } else if (firstPageTotalRow+baseRow<=16) {
                    //sepNode.style.height='20mm';
                  }

                }

                //if (this.moreBasal) {
                if (false) {
                  if (this.basalPagePos>0 || this.basalPagePos2>0) {
                    if (leftBasalRow > 9) {
                      this.bolusStartPage.show=true;
                      this.pdmStartPage.show=false;
                      this.cgmStartPage.show=false;
                    } else if (leftBasalRow > 5) {
                      this.bolusStartPage.show=false;  // 不分页， 往上靠。
                      this.pdmStartPage.show=true;
                      this.cgmStartPage.show=false;
                    } else if (leftBasalRow > 1) {
                      this.bolusStartPage.show=false;  // 不分页， 往上靠。
                      this.pdmStartPage.show=false;  // 不分页， 往上靠。
                      this.cgmStartPage.show=true;
                    } else if (leftBasalRow == 1) {
                      this.bolusStartPage.show=false;  // 不分页， 往上靠。
                      this.pdmStartPage.show=false;  // 不分页， 往上靠。
                      this.cgmStartPage.show=false;   // 不分页， 往上靠。
                    } else {
                      this.bolusStartPage.show=true;  // 不分页， 往上靠。
                      this.pdmStartPage.show=false;  // 不分页， 往上靠。
                      this.cgmStartPage.show=false;   // 不分页， 往上靠。
                    }
                  } else {   // 基础量表格没有分页。
                    this.bolusStartPage.show=true;
                    this.pdmStartPage.show=false;
                    this.cgmStartPage.show=false;
                  }
                } else if (false) {

                  let backgroundNode=document.getElementById('background');
                  let containerNode=document.getElementById('chart-container');
                  let pageNum=4;

                  if (this.basalPagePos>0 || this.basalPagePos2>0) {

                    if (leftBasalRow > 1) {  //  新的一页显示了3,4行基础量表格的时候， 只能显示bolus 和 pdm
                      this.bolusStartPage.show=false;
                      this.pdmStartPage.show=false;
                      this.cgmStartPage.show=true;
                      //this.cgmSep5=true;
                      let cgmPageId='cgmStartPage';
                      console.log("cgmPageId:", cgmPageId);
                      let sepNode=document.getElementById(cgmPageId);
                      //sepNode.style.height='55mm';

                    } else if (leftBasalRow > 0) {
                      this.bolusStartPage.show=false;
                      this.pdmStartPage.show=false;
                      this.cgmStartPage.show=false;
                      pageNum=3;
                    } else if (leftBasalRow == 0) {
                      this.bolusStartPage.show=true;
                      this.pdmStartPage.show=false;
                      this.cgmStartPage.show=false;
                      pageNum=3;
                    }

                  } else {  // basal的表格没有分页
                    pageNum=3;
                    if (leftBasalRow > 10) {
                      let bolusPageId='bolusStartPage';
                      console.log("bolusPageId:", bolusPageId);
                      let sepNode=document.getElementById(bolusPageId);
                      if (leftBasalRow>=16) {
                        //sepNode.style.height='20mm';
                      } else if (leftBasalRow>=14) {
                        //sepNode.style.height='45mm';
                      } else if (leftBasalRow>=13) {
                        //sepNode.style.height='60mm';
                      } else if (leftBasalRow>=12) {
                        //sepNode.style.height='80mm';
                      } else if (leftBasalRow>=11) {
                        //sepNode.style.height='95mm';
                      }

                      this.bolusStartPage.show=true;  // true
                      this.pdmStartPage.show=false;
                      this.cgmStartPage.show=false;

                    } else if (leftBasalRow > 5) {
                      let pdmPageId='pdmStartPage';
                      console.log("pdmPageId:", pdmPageId);
                      let sepNode=document.getElementById(pdmPageId);

                      if (leftBasalRow>=10) {
                        //sepNode.style.height='20mm';
                      } else if (leftBasalRow>=7) {
                        //sepNode.style.height='50mm';
                      } else if (leftBasalRow>=6) {
                        //sepNode.style.height='70mm';
                      }

                      this.bolusStartPage.show=false;  // 不分页， 往上靠。
                      this.pdmStartPage.show=true;
                      this.cgmStartPage.show=false;
                      //} else if (leftBasalRow > 1) {
                    } else {
                      this.bolusStartPage.show=false;  // 不分页， 往上靠。
                      this.pdmStartPage.show=false;  // 不分页， 往上靠。
                      this.cgmStartPage.show=true;
                    }
                    this.pumpStartPage.show=true;
                    /*else if (leftBasalRow == 1) {
                      this.bolusStartPage.show=false;  // 不分页， 往上靠。
                      this.pdmStartPage.show=false;  // 不分页， 往上靠。
                      this.cgmStartPage.show=false;   // 不分页， 往上靠。
                    } else {
                      this.bolusStartPage.show=true;  // 不分页， 往上靠。
                      this.pdmStartPage.show=false;  // 不分页， 往上靠。
                      this.cgmStartPage.show=false;   // 不分页， 往上靠。
                    }
                    */
                    //backgroundNode.style.height=(240*pageNum+10)+'mm';
                    //containerNode.style.height=(240*pageNum+10)+'mm';
                  }
                }  // if (moreBasal)

                let backgroundNode=document.getElementById('background');
                let containerNode=document.getElementById('chart-container');
                let pageNum=4;

                if (this.basalPagePos2<0 && this.basalPagePos<0) {  // basal 一页没分
                  if (this.moreBasal) {
                    leftBasalRow += 4;
                  }
                  pageNum=3;
                } else if (this.basalPagePos2>0 && this.basalPagePos>0) {
                  if (leftBasalRow > 1) {
                    pageNum=5;
                  } else {
                    pageNum=4;
                  }
                } else if (this.basalPagePos>0 && this.basalPagePos2<0) {
                  if (leftBasalRow > 1) {
                    pageNum=4;
                  } else {
                    pageNum=3;
                  }
                }

                //backgroundNode.style.height=((297+2)*pageNum+10)+'mm';
                //containerNode.style.height=((297+2)*pageNum+10)+'mm';
                console.log("leftBasalRow:", leftBasalRow, pageNum);

                //  统一用下面这段代码处理
                if (leftBasalRow > 10) {
                  let bolusPageId='bolusStartPage';
                  console.log("bolusPageId:", bolusPageId);
                  let sepNode=document.getElementById(bolusPageId);
                  if (leftBasalRow>=16) {
                    //sepNode.style.height='20mm';
                  } else if (leftBasalRow>=14) {
                    //sepNode.style.height='45mm';
                  } else if (leftBasalRow>=13) {
                    //sepNode.style.height='60mm';
                  } else if (leftBasalRow>=12) {
                    //sepNode.style.height='80mm';
                  } else if (leftBasalRow>=11) {
                    //sepNode.style.height='95mm';
                  }

                  this.bolusStartPage.show=true;  // true, bolus 另起一页.
                  this.pdmStartPage.show=false;
                  this.cgmStartPage.show=false;

                } else if (leftBasalRow > 5) {

                  let pdmPageId='pdmStartPage';
                  console.log("pdmPageId:", pdmPageId);
                  let sepNode=document.getElementById(pdmPageId);

                  if (leftBasalRow>=10) {
                    //sepNode.style.height='20mm';
                  } else if (leftBasalRow>=7) {
                    //sepNode.style.height='50mm';
                  } else if (leftBasalRow>=6) {
                    //sepNode.style.height='70mm';
                  }

                  this.bolusStartPage.show=false;  // 不分页， 往上靠。 bolus放到basal 里面去
                  this.pdmStartPage.show=true;
                  this.cgmStartPage.show=false;
                  //} else if (leftBasalRow > 1) {
                } else if (leftBasalRow > 1) {

                  let cgmPageId='cgmStartPage';
                  console.log("cgmPageId:", cgmPageId);
                  let sepNode=document.getElementById(cgmPageId);

                  if (leftBasalRow>=5) {
                    //sepNode.style.height='20mm';
                  } else if (leftBasalRow>=4) {
                    //sepNode.style.height='40mm';
                  } else if (leftBasalRow>=3) {
                    //sepNode.style.height='55mm';
                  } else if (leftBasalRow>=2) {
                    //sepNode.style.height='70mm';
                  }

                  this.bolusStartPage.show=false;  // 不分页， 往上靠。
                  this.pdmStartPage.show=false;  // 不分页， 往上靠。
                  this.cgmStartPage.show=true;
                }
                this.pumpStartPage.show=true;

              }
            }

            this.basal = this.data.basal_settings;
            this.basal.max_rate = (this.basal.max_rate)?this.basal.max_rate.toFixed(2):'--';
            //if(this.basal.basal_select==='Exercise'){
              this.basalSeg = this.basal.exer_basal.seg;
              this.total = this.basal.exer_basal.day_total.toFixed(2);
              this.exeBasal = auth.getPdmSG(this.data.basal_settings.exer_basal.seg);
            //}
            //if(this.basal.basal_select==='Standard'){
              this.basalSeg = this.basal.stand_basal.seg;
              this.total = this.basal.stand_basal.day_total.toFixed(2);
              this.standBasal = auth.getPdmSG(this.data.basal_settings.stand_basal.seg);
            //}
            //if(this.basal.basal_select==='Holiday'){
              this.basalSeg = this.basal.holiday_basal.seg;
              this.total = this.basal.holiday_basal.day_total.toFixed(2);
              this.holidayBasal = auth.getPdmSG(this.data.basal_settings.holiday_basal.seg);
            //}
            //if(this.basal.basal_select==='ProgramA'){
              this.basalSeg = this.basal.program_a_basal.seg;
              this.total = this.basal.program_a_basal.day_total.toFixed(2);
              this.programA = auth.getPdmSG(this.data.basal_settings.program_a_basal.seg);
            //}
            //if(this.basal.basal_select==='ProgramB'){
              this.basalSeg  = this.basal.program_b_basal.seg;
              this.total = this.basal.program_b_basal.day_total.toFixed(2);
              this.programB = auth.getPdmSG(this.data.basal_settings.program_b_basal.seg);
            //}

            this.axisMaxArr[0] = this.getAxisMax(this.data.basal_settings.stand_basal.seg)
            this.axisMaxArr[1] = this.getAxisMax(this.data.basal_settings.exer_basal.seg)
            this.axisMaxArr[2] = this.getAxisMax(this.data.basal_settings.holiday_basal.seg)
            this.axisMaxArr[3] = this.getAxisMax(this.data.basal_settings.program_a_basal.seg)
            this.axisMaxArr[4] = this.getAxisMax(this.data.basal_settings.program_b_basal.seg)

            if (this.moreBasal){
              this.basalSeg  = this.basal.program_c_basal.seg;
              this.total = this.basal.program_c_basal.day_total.toFixed(2);
              this.programC = auth.getPdmSG(this.data.basal_settings.program_c_basal.seg);
              //
              this.basalSeg  = this.basal.program_d_basal.seg;
              this.total = this.basal.program_d_basal.day_total.toFixed(2);
              this.programD = auth.getPdmSG(this.data.basal_settings.program_d_basal.seg);
              //
              this.basalSeg  = this.basal.sick_basal.seg;
              this.total = this.basal.sick_basal.day_total.toFixed(2);
              this.sickBasal = auth.getPdmSG(this.data.basal_settings.sick_basal.seg);

              this.axisMaxArr[5] = this.getAxisMax(this.data.basal_settings.program_c_basal.seg)
              this.axisMaxArr[6] = this.getAxisMax(this.data.basal_settings.program_d_basal.seg)
              this.axisMaxArr[7] = this.getAxisMax(this.data.basal_settings.sick_basal.seg)

            }

            //
            for(let i =0;i<this.basalSeg.length;i++){
              if(i<12){
                this.bsg1.push(this.basalSeg[i])
              }
              else if(i<24){
                this.bsg2.push(this.basalSeg[i])
              }
              else if(i<36){
                this.bsg3.push(this.basalSeg[i])
              }
              else{
                this.bsg4.push(this.basalSeg[i])
              }
            }

            // basalInfo
            this.basalInfo[0].total=this.basal.stand_basal.day_total.toFixed(2);;
            this.basalInfo[0].title=this.$t('Standard');
            this.standardSeg=this.basal.stand_basal.seg;

            this.basalInfo[1].total=this.basal.exer_basal.day_total.toFixed(2);;
            this.basalInfo[1].title=this.$t('Exercise');
            this.exerSeg=this.basal.exer_basal.seg;

            this.basalInfo[2].total=this.basal.holiday_basal.day_total.toFixed(2);;
            this.basalInfo[2].title=this.$t('Holiday');
            this.holidaySeg=this.basal.holiday_basal.seg;

            this.basalInfo[3].total=this.basal.program_a_basal.day_total.toFixed(2);;
            this.basalInfo[3].title=this.$t('ProgramA');
            this.programASeg=this.basal.program_a_basal.seg;

            this.basalInfo[4].total=this.basal.program_b_basal.day_total.toFixed(2);;
            this.basalInfo[4].title=this.$t('ProgramB');
            this.programBSeg=this.basal.program_b_basal.seg;

            if (this.moreBasal){
              this.basalInfo[5].total=this.basal.program_c_basal.day_total.toFixed(2);;
              this.basalInfo[5].title=this.$t('t1028_Pattern_C');
              this.programCSeg=this.basal.program_c_basal.seg;

              this.basalInfo[6].total=this.basal.program_d_basal.day_total.toFixed(2);;
              this.basalInfo[6].title=this.$t('t1028_Pattern_D');
              this.programDSeg=this.basal.program_d_basal.seg;

              this.basalInfo[7].total=this.basal.sick_basal.day_total.toFixed(2);;
              this.basalInfo[7].title=this.$t('t1029_Sick');
              this.sickSeg=this.basal.sick_basal.seg;
            } else {
              this.basalInfo.splice(5,3);
            }

            var segName= ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg',
              'programCSeg', 'programDSeg', 'sickSeg'];
            if (!this.moreBasal) {
              segName.splice(5,3);
            }

            for (let n=0; n<segName.length; n++) {
              this.basalInfo[n].bsg1=[];
              this.basalInfo[n].bsg2=[];
              this.basalInfo[n].bsg3=[];
              this.basalInfo[n].bsg4=[];

              this.basalInfo[n].bsg2show=false;
              this.basalInfo[n].bsg3show=false;
              this.basalInfo[n].bsg4show=false;
            }

            for (let n=0; n<segName.length; n++) {
              let curSeg=this[segName[n]];
              curSeg=curSeg.map(function(e, i){
                return [e[0],e[1].toFixed(2)];
              });
              for(let i =0;i<curSeg.length;i++){
                if(i<12){
                  this[segName[n]+'1'].push(curSeg[i])
                  this.basalInfo[n].bsg1.push(curSeg[i]);
                }
                else if(i<24){
                  this[segName[n]+'2'].push(curSeg[i])
                  this.basalInfo[n].bsg2.push(curSeg[i]);
                  this.basalInfo[n].bsg2show=true;
                }
                else if(i<36){
                  this[segName[n]+'3'].push(curSeg[i])
                  this.basalInfo[n].bsg3.push(curSeg[i]);
                  this.basalInfo[n].bsg3show=true;
                }
                else{
                  this[segName[n]+'4'].push(curSeg[i])
                  this.basalInfo[n].bsg4.push(curSeg[i]);
                  this.basalInfo[n].bsg4show=true;
                }
              }
            }
            //
            this.bolus = this.data.bolus_settings;
            this.IcRatio = this.data.bolus_settings.ins_carb_ratio;
            this.ins_sen = this.data.bolus_settings.ins_sen;
            this.bg_target = this.data.bolus_settings.bg_target;
            this.bolus_rem = this.data.bolus_settings.bolus_reminder;

            this.userset = this.data.user_settings;
            this.userset.sensor_sn = (this.userset.sensor_sn)?this.userset.sensor_sn:'--';
            this.userset.user_name = (this.userset.user_name)?this.userset.user_name:'--';
            this.userset.sensor_expire_option = (this.userset.sensor_expire_option)?this.$t(this.userset.sensor_expire_option):'--';
            this.userset.pump_sn = (this.userset.pump_sn)?this.userset.pump_sn:'--';
            this.userset.alarm_type = (this.userset.alarm_type)?this.$t(this.userset.alarm_type):'--';
            this.userset.low_reservoir_time = (this.userset.low_reservoir_type==='time')?this.userset.low_reservoir_time:this.$t(this.userset.low_reservoir_type)+' '+this.userset.low_reservoir_ins+ins_unit2;
            let opt = this.userset.patch_expire_alarm;
            this.userset.patch_expire_alarm = (opt==='On')?this.$t(opt)+' '+this.userset.patch_expire_ahead+'H':this.$t(opt);
            this.userset.auto_off_option = (this.userset.auto_off_option==='On')?this.$t(this.userset.auto_off_option)+' '+this.userset.auto_off_time+'H':this.$t(this.userset.auto_off_option);
            this.userset.pre_suspend_on_lowbg_option = (this.userset.pre_suspend_on_lowbg_option==='On')?this.$t(this.userset.pre_suspend_on_lowbg_option)+' '+this.userset.pre_suspend_on_lowbg_level:this.$t(this.userset.pre_suspend_on_lowbg_option);
            if(this.userset.clock){
              let that =this;
              this.userset.clock.map(function (e,i) {
                e[1] = that.$t(e[1]);
              })
            }

            this.userset.suspend_on_lowbg_option =this.$t( this.userset.suspend_on_lowbg_option);
            if( this.userset.suspend_on_lowbg_option===this.$t('On')){
              this.userset.suspend_on_lowbg_level =(this.isMg)?parseInt(this.userset.suspend_on_lowbg_level):this.userset.suspend_on_lowbg_level.toFixed(1);
              //this.userset.suspend_on_lowbg_option =this.userset.suspend_on_lowbg_option+' '+this.userset.suspend_on_lowbg_level+this.unit1;
            }
            // 自动模式相关的设置
            if (this.userset.auto_basal) {
              let auto_basal=this.userset.auto_basal;
              // if (1==auto_basal.autobasalflag) {
              //   auto_basal.autobasalflag = this.$t('Off')
              // } else if (2==auto_basal.autobasalflag) {
              //   auto_basal.autobasalflag = this.$t('On')
              // }
              auto_basal.autobasalflag = this.getOptionText(auto_basal.autobasalflag);

              //if ('mg/dL' == this.userset.glucose_unit) {
              if (this.isMg){
                if (0==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '100 mg/dL'
                } else if (1==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '110 mg/dL'
                } else if (2==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '120 mg/dL'
                }
              } else {
                if (0==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '5.6 mmol/L'
                } else if (1==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '6.1 mmol/L'
                } else if (2==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '6.7 mmol/L'
                }
              }
              auto_basal.nFoodFlag = this.getOptionText(auto_basal.nFoodFlag);
              //
              if (!auto_basal.AutoBasalWeight) {
                auto_basal.AutoBasalWeight='--';
              }
              if (!auto_basal.AutoBasalTDD) {
                auto_basal.AutoBasalTDD='--';
              }

            } else {
              this.userset.auto_basal={};
            }

            let option = this.$t(this.data.bolus_settings.bolus_reminder_option);
            this.maxBolOption = ' ('+option+ ')';

            this.pumpSN = (this.userset.pump_sn)?this.userset.pump_sn:'--';
            this.tranSN =(this.userset.sensor_sn)?this.userset.sensor_sn:'--';
            this.pumpSN = auth.deviceSNFormat(this.pumpSN, 'PUMP');
            this.tranSN = auth.deviceSNFormat(this.tranSN, 'TRANS');

            this.userset.clock.map(function (e,i) {
              let time = auth.getTime2(e[0]);
              e[0] = time[0]+":"+time[1];
              return e;
            });


            this.cgm = this.data.sensor_settings;
            if(this.cgm.sensor_rate_alarm){
              this.cgm.sensor_rate_alarm.fall[1] = (this.cgm.sensor_rate_alarm.fall[0]!=="Off")?this.cgm.sensor_rate_alarm.fall[1].toFixed(3):'--';
              this.cgm.sensor_rate_alarm.rise[1] = (this.cgm.sensor_rate_alarm.rise[0]!=="Off")?this.cgm.sensor_rate_alarm.rise[1].toFixed(3):'--';
            }
            if(this.cgm.sensor_alarm_repeat){
              this.cgm.sensor_alarm_repeat.high[1] = (this.cgm.sensor_alarm_repeat.high[0]!=="Off")? this.cgm.sensor_alarm_repeat.high[1]:'--';
              this.cgm.sensor_alarm_repeat.low[1] = (this.cgm.sensor_alarm_repeat.low[0]!=="Off")? this.cgm.sensor_alarm_repeat.low[1]:'--';
            }
            if(this.cgm.sensor_forecast_alarm){
              this.cgm.sensor_forecast_alarm.high[1] = (this.cgm.sensor_forecast_alarm.high[0]!=="Off")? this.cgm.sensor_forecast_alarm.high[1]:'--';
              this.cgm.sensor_forecast_alarm.low[1] = (this.cgm.sensor_forecast_alarm.low[0]!=="Off")? this.cgm.sensor_forecast_alarm.low[1]:'--';
            }
            this.cgm.sensor_alarm_settings.calib_remind_time = (this.cgm.sensor_alarm_settings.calib_remind_option!=='Off')?this.cgm.sensor_alarm_settings.calib_remind_time:"--";
            this.cgm.sensor_alarm_settings.calib_remind_interval = (this.cgm.sensor_alarm_settings.auto_calib_option!=='Off')?this.cgm.sensor_alarm_settings.calib_remind_interval:"--";
            this.cgmLimit = this.cgm.sensor_alarm_threshold;

            let basal_select_map = {
              'ProgramC':'t1028_Pattern_C',
              'ProgramD':'t1028_Pattern_D',
              'Sick':'t1029_Sick',
            }
            if (basal_select_map[this.basal.basal_select]) {
              this.basal.basal_select = basal_select_map[this.basal.basal_select];
            }
            this.basal.basal_select = this.$t(this.basal.basal_select);
            this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
            this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
            this.bolus.extent_option = this.$t(this.bolus.extent_option);
            this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
            this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
            this.userset.cmd_response = this.$t(this.userset.cmd_response);
            this.userset.clock_option = this.$t(this.userset.clock_option);
            this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

            this.cgm.sensor_rate_alarm.fall[0] =this.$t(this.cgm.sensor_rate_alarm.fall[0]);
            this.cgm.sensor_rate_alarm.rise[0] =this.$t(this.cgm.sensor_rate_alarm.rise[0]);
            this.cgm.sensor_alarm_repeat.high[0] =this.$t(this.cgm.sensor_alarm_repeat.high[0]);
            this.cgm.sensor_alarm_repeat.low[0] =this.$t(this.cgm.sensor_alarm_repeat.low[0]);
            this.cgm.sensor_forecast_alarm.high[0] =this.$t(this.cgm.sensor_forecast_alarm.high[0]);
            this.cgm.sensor_forecast_alarm.low[0] =this.$t(this.cgm.sensor_forecast_alarm.low[0]);
            this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
            this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
            this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);
            if(this.chart6_1){
              this.chart6_1.dispose();
            }
            if(this.chart6_2){
              this.chart6_2.dispose();
            }
            if(this.chart6_3){
              this.chart6_3.dispose();
            }
            if(this.chart6_4){
              this.chart6_4.dispose();
            }
            if(this.chart6_5){
              this.chart6_5.dispose();
            }

            if (this.moreBasal) {
              if(this.chart6_6){
                this.chart6_6.dispose();
              }
              if(this.chart6_7){
                this.chart6_7.dispose();
              }
              if(this.chart6_8){
                this.chart6_8.dispose();
              }
            }

            this.drawChart6_1('chart6_1', this.standBasal, this.$t('Standard'), this.axisMaxArr[0]);
            this.drawChart6_1('chart6_2', this.exeBasal, this.$t('Exercise'), this.axisMaxArr[1]);
            this.drawChart6_1('chart6_3', this.holidayBasal, this.$t('Holiday'), this.axisMaxArr[2]);
            this.drawChart6_1('chart6_4', this.programA, this.$t('ProgramA'), this.axisMaxArr[3]);
            this.drawChart6_1('chart6_5', this.programB, this.$t('ProgramB'), this.axisMaxArr[4]);
            if (this.moreBasal) {
              this.drawChart6_1('chart6_6', this.programC, this.$t('t1028_Pattern_C'), this.axisMaxArr[5]);
              this.drawChart6_1('chart6_7', this.programD, this.$t('t1028_Pattern_D'), this.axisMaxArr[6]);
              this.drawChart6_1('chart6_8', this.sickBasal, this.$t('t1029_Sick'), this.axisMaxArr[7]);
            }
          }
        });
      },
      drawChart6_1(chartId, basalPattern, chartTitle, axisMax) {
        //this.chart6_1 = echarts.init(document.getElementById('chart6_1'));
        this[chartId]=echarts.init(document.getElementById(chartId));
        //this.chart6_1.setOption({
        this[chartId].setOption({
          title: {
            //text: this.$t('basal')+' (U/H)',
            text: chartTitle + ' '+this.$t('basal_unit'),
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(new Date().setHours(0,0,0,0)),
            max:new Date(new Date().setHours(0,0,0,0)+86400000),
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
            splieLine:{show:true},
            axisLabel:{
              showMaxLabel:true,
              margin: 20, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                let zero_hour=new Date();
                zero_hour.setHours(0,0,0,0);
                index = (value - zero_hour.getTime()) / 3600000;
                let H=index;
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  return  '24:00';
                }
              }
            },
          }],
          yAxis: [{
            type: 'value',
            min:0,
            max:axisMax,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
            splitLine:{show:true},
            splitNumber:2,
          }],
          grid: this.grid,
          series: [
            {
              type:'line',
              step:'end',
              //data:this.exeBasal,
              data:basalPattern,
              itemStyle: {normal: {
                color:'#0e0',
              }},
              symbolSize:1,
            },
            /*
            {
              type:'line',
              data:this.standBasal,
              itemStyle: {normal: {
                color:'#0e0',
              }},
              symbolSize:1,
            },
            {
              type:'line',
              data:this.holidayBasal,
              itemStyle: {normal: {
                color:'#0e0',
              }},
              symbolSize:1,
            },
            {
              type:'line',
              data:this.programA,
              itemStyle: {normal: {
                color:'#0e0',
              }},
              symbolSize:1,
            },
            {
              type:'line',
              data:this.programB,
              itemStyle: {normal: {
                color:'#0e0',
              }},
              symbolSize:1,
            },*/
          ],
        });
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('Device Settings Report');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de'||lang==='it')?true:false;
      this.isFr =(lang==='fr')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.unit1 = (this.isMg)?'mg/dL':'mmol/L';
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      let pdm = sessionStorage.getItem('qPdm').split(',');
      this.pdmSN = pdm[1];
      if ('EasyPatch'==this.pdmSN) {
        this.pdmTitle = 'APP';
      } else {
        this.pdmTitle = this.$t('pdm')
      }
      this.rid =parseInt(sessionStorage.getItem('qRid'));
      let ti =  pdm[0].split(' ');
      let tt = ti[0].split('-');
      this.time = tt[0]+'/'+tt[1]+'/'+tt[2]+' '+ti[1];
      this.getStatics();
      this.getPdm2()
      let first = parseInt(sessionStorage.getItem('qFirst8'));
      if(first===1){
        auth.checkPrint(this,9,8);
      }
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *height: 800mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *height:800mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }

  .statics{
    margin-top: 15px;
    margin-bottom: 17px;
  }
  .statics p{
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:11px;
    color:#282828;
    letter-spacing:-0.27px;
    text-align:left;
    padding-left: 3px;
    border-left: 2px solid #009fdf;;
  }
  .statics .custom{
    border:none;
    padding-left: 5px;
    float: left;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:20px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .spe-text{
    float: right;
    min-width: 140px;
    margin-right: 25px;
  }
  .spe-text p{
    border:none;
    float: right;

  }
  .small-table{
    width: 30.6%;
    float: left;
    margin-left: 2%;
    margin-top: -5px;
  }
  .middle-table{
    width: 50%;
    float: left;
    margin-left: 1%;
    margin-top: -5px;
  }

  .context{
    width: 93%;
    margin:0 auto;
  }
  .context p{
    font-family:SFUIText-Regular;
    font-size:10px;
    color:#282828;
    letter-spacing:-0.24px;
    text-align:left;
    margin-left: 2px;
  }
  .chart-container .graph{
    width:103%;
    height: 125px;
    margin-left: -2.5%;
    margin-top: 10px;
  }

  .page-seperator {
    height:10mm;
  }

  .page-seperator2 {
    *height:20mm;
    page-break-before: always;
  }

  .page-seperator3 {
    *height:30mm;
    page-break-before: always;
  }

  .page-seperator4 {
    *height:40mm;
    page-break-before:always;
  }

  .page-seperator45 {
    *height:45mm;
    page-break-before:always;
  }

  .page-seperator5 {
    *height:50mm;
    page-break-before: always;
  }
  .page-starter {
    height:10mm;
  }

  .page-seperator6 {
    height:60mm;
  }

  .page-seperator7 {
    height:70mm;
  }

  .page-seperator75 {
    height:75mm;
  }

  .page-seperator8 {
    height:80mm;
  }

  .page-seperator9 {
    height:90mm;
  }

  .x_page4{
    height:1020mm;
  }

  .sep5 {
    height:50mm;
  }

  .sep6 {
    height:60mm;
  }
</style>



// WEBPACK FOOTER //
// quickPrint8.vue?63daa8bc